import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorHandlingActions } from '../../../../shared/store/redux/error-handling-slice';
import { postJson } from '../../../../shared/utils/utils';
import { DynamicMessageTypeEnum } from '../../../../shared/enums/DynamicMessageTypeEnum';
import { getDelayNavigateUrl } from '../../../../shared/components/features/navigateLink/navigateLinkUtils';
import gaSectionType from '../../../../shared/enums/gaSectionType';
import googleMeetIcon from "../../../../assests/googleMeet/googleMeetWidgetStudent.png";
import classes from './GoogleMeetBtn.module.css';
import Icon from '../../../../shared/components/ui/icons/Icon';
import iconsList from '../../../../shared/components/ui/icons/iconsList';

const GoogleMeetBtn = ({ studyGroup, copyBtn }) => {

    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isCopying, setIsCopying] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);

    const fetchMeetLink = async () => {
        const res = await postJson(`${window.config.baseApiUrl}/api/cloudenv/link/${studyGroup.id}`);
        if (res.ok && res.body && res.body.statusCode !== 422) {
            return getDelayNavigateUrl({
                link: res.body.link,
                reloadOpener: 0,
                ga: { section: gaSectionType.meet },
            });
        } else {
            throw new Error(res.body?.statusCode === 422 ? 'noGoogleAccount' : 'generalError');
        }
    };

    const moveToMeet = async () => {
        if (isLoading)
            return;
        setIsLoading(true);
        try {
            const link = await fetchMeetLink();
            window.open(link, "_blank");
        } catch (err) {
            dispatch(errorHandlingActions.throwError({
                userMessage: err.message === 'noGoogleAccount' ? texts.userNoGoogleAccountInSchool : texts.generalError,
                message: err.message,
                level: 2,
                type: DynamicMessageTypeEnum.Error
            }));
        } finally {
            setIsLoading(false);
        }
    };

    const copyMeetLink = async () => {
        if (isCopying) return;
        setIsCopying(true);
        try {
            const link = await fetchMeetLink();
            await navigator.clipboard.writeText(link);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000); // להעלים את ההודעה אחרי 2 שניות
        } catch (err) {
            dispatch(errorHandlingActions.throwError({
                userMessage: texts.generalError,
                message: err.message,
                level: 2,
                type: DynamicMessageTypeEnum.Error
            }));
        } finally {
            setIsCopying(false);
        }
    };

    return (
        <div className={classes.GoogleMeetBtn}>
            {copyBtn && (
                <div className={classes.copyWrapper}>
                    {copySuccess && <span className={classes.CopyMessage}>{texts.copy}</span>}
                    <Icon
                        name={iconsList.copy}
                        size={24}
                        color="black"
                        className={classes.copyButton}
                        onClick={(e) => { e.stopPropagation(); copyMeetLink(); }}
                    // disabled={isCopying}
                    />
                </div>
            )}
            <div className={classes.GoogleMeetBtn} onClick={moveToMeet}>
                <img className={classes.GoogleMeetIcon} src={googleMeetIcon} alt="Google Meet" />
            </div>
        </div>
    );
}
export default GoogleMeetBtn;
